<template>
    <div class="modal fade" id="klammerModal" tabindex="-1" role="dialog" aria-labelledby="klammerModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content ">
        <div class="modal-header">
            <h5 class="modal-title" id="klammerModalTitle">Klammerbild</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
                <img src="../assets/img/Klammer.jpg" width="100%">
        </div>
        </div>
    </div>
    </div>
</template>


<script>

export default {
  name: 'KlammerModal',
  props: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
